import { useEffect, useRef } from 'react';

interface UseReportBreedSearchedOptions {
  searchKey: string;
  isReady: boolean;
  report: () => void;
}

/**
 * Reports a search once per result set the visitor is shown.
 *
 * Keyed on the search rather than the query's status: results are cached with
 * `staleTime: Infinity`, so one the visitor has already run comes back with a
 * status that never transitions.
 */
export default function useReportBreedSearched({
  searchKey,
  isReady,
  report
}: UseReportBreedSearchedOptions) {
  const reportedRef = useRef<string | null>(null);

  // `report` is a new function every render, so it is not a dependency.
  useEffect(() => {
    if (!isReady || reportedRef.current === searchKey) {
      return;
    }

    reportedRef.current = searchKey;
    report();
  }, [isReady, searchKey]);
}
